export type PasswordSetupStatus = 'complete' | 'pending' | 'expired'

export function passwordSetupNeedsResend(status?: PasswordSetupStatus): boolean {
  return status === 'pending' || status === 'expired'
}

export function passwordSetupLabel(status?: PasswordSetupStatus): string {
  switch (status) {
    case 'pending':
      return 'Aguardando cadastro'
    case 'expired':
      return 'Convite expirado'
    default:
      return 'Senha definida'
  }
}

export function passwordSetupBadgeVariant(
  status?: PasswordSetupStatus,
): 'success' | 'warning' | 'muted' {
  switch (status) {
    case 'pending':
      return 'warning'
    case 'expired':
      return 'muted'
    default:
      return 'success'
  }
}
